<template>
  <div style="background: #1E263A;color: #fff;min-width: 1200px;">
    <div class="content"
         style="padding:30px 0 20px 0;">
      <div class="flex-between">
        <div class="leftcontent flex-column"
             style="height: 220px;border-right:1px solid rgba(255,255,255,0.17);padding-right:60px;">
          <!-- <div class="flex-column" style="color: #0092FF;">
                        <div class="logoText">千顷职汇</div>
                        <div class="">yuyingrencai</div>
                    </div> -->
          <!-- <el-image :src="require(`@/static/image/logo.png`)"
                        style="width: 184px;height: 34px;margin-left: -10px;" fit="fill"></el-image> -->
          <p style="margin-top: 10px;">企业服务热线和算法/未成年人等举报渠道道： </p>
          <p class="bold"
             style="font-weight: 16px;"
             v-if="info.service_phone">{{ info.service_phone || '' }}
          </p>
          <p v-if="info.service_time">{{ info.service_time || '' }} </p>
          <p class="bold"
             style="font-weight: 16px;"
             v-if="info.email">{{ info.email }} </p>
        </div>
        <div class="rightcontent flex-between"
             style="flex: 0 0 60%; height: 220px;padding-left:80px;align-items: baseline;">
          <div class="flex-between"
               style="flex:0 0 80%;align-items:baseline">
            <div class="bottom-items"
                 style="flex: 0 0 20%;">
              <p v-if="info.bottom_nav.title_1">{{ info.bottom_nav.title_1 }}</p>
              <div style="margin-top: 20px;">
                <p class="bottom-text"
                   v-for="(item, index) in info.bottom_nav.nav1List"
                   :key="index"><a :href="item.link"
                     target="_blank">{{ item.title }}</a></p>
              </div>
            </div>
            <div class="bottom-items"
                 style="flex: 0 0 20%;">
              <p v-if="info.bottom_nav.title_2">{{ info.bottom_nav.title_2 }}</p>
              <div style="margin-top: 20px;">
                <p class="bottom-text"
                   v-for="(item, index) in info.bottom_nav.nav2List"
                   :key="index"><a :href="item.link"
                     target="_blank">{{ item.title }}</a></p>
              </div>
            </div>
            <div class="bottom-items"
                 style="flex: 0 0 20%;">
              <p v-if="info.bottom_nav.title_3">{{ info.bottom_nav.title_3 }}</p>
              <div style="margin-top: 20px;">
                <p class="bottom-text"
                   v-for="(item, index) in info.bottom_nav.nav3List"
                   :key="index"><a :href="item.link"
                     target="_blank">{{ item.title }}</a></p>
              </div>
            </div>
          </div>
          <div class="bottom-items"
               style="flex: 0 0 20%;text-align: center;">
            <p>联系客服</p>
            <div style="margin:0 auto;margin-top: 20px;border:1px solid rgba(255,255,255,0.17);padding:10px;width: 130px;height: 140px;">
              <el-image :src="info.src"
                        style="width: 100px;height: 99px; "
                        fit="fill"></el-image>
              <p>(扫一扫)</p>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="content fotter">
      <p>
        <span v-if="info.icp"><a href="https://beian.miit.gov.cn/"
             target="_blank">{{ info.icp
                }}</a></span>&nbsp;<span v-if="info.icp_auth">{{ info.icp_auth }}</span>&nbsp;<span v-if="info.ga">{{ info.ga }}</span>&nbsp;<span class="cursor"
              @click="getInfo('privacy')">个人信息
          保护政策</span>&nbsp;<span class="cursor"
              @click="getInfo('user_agreement')">用户服务协议</span>

      </p>
      <p class="cursor"
         @click="getInfo('reporting')">违法和不良信息举报</p>
    </div>
  </div>
</template>

<script>
import config from '@/config/config'
export default {
  name: '',
  components: {},
  data() {
    return {
      src: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      info: {
        bottom_nav: {
          title_1: '',
          title_2: '',
          title_3: '',
        },
      },
    }
  },
  computed: {},
  watch: {},
  methods: {
    getConfig() {
      this.$api.index.getConfig().then((res) => {
        if (res.code == 200) {
          console.log(res.data.about_pic, 'about_pic')
          console.log(res.data.about_top_banner, 'about_top_banner')
          localStorage.setItem('about_pic', config.config + res.data.about_pic)
          localStorage.setItem(
            'about_top_banner',
            config.config + res.data.about_top_banner
          )
          console.log(localStorage.getItem('about_top_banner'))

          res.data.src = config.config + res.data.mini_qr
          res.data.bottom_nav.nav1List = []
          res.data.bottom_nav.nav2List = []
          res.data.bottom_nav.nav3List = []
          this.info = res.data || {}
          for (let j = 1; j < 4; j++) {
            // console.log(j,'j', res.data.bottom_nav[`nav${j}List`]);
            for (let i = 1; i < 6; i++) {
              // console.log('res.data.bottom_nav',i,res.data.bottom_nav[`nav${j}`]);
              this.info.bottom_nav[`nav${j}List`].push({
                title: this.info.bottom_nav[`nav${j}`][`nav_${i}_title`],
                link: this.info.bottom_nav[`nav${j}`][`nav_${i}_link`],
              })
            }
          }
        }
      })
    },
    getInfo(type) {
      this.$router.push({
        path: '/article',
        query: {
          type: type,
        },
      })
      this.$router.go(0)
    },
  },
  mounted() {
    this.getConfig()
  },
}
</script>
<style lang='scss' scoped>
.fotter {
  font-weight: 500;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.27);
  padding: 30px 0 10px 0;
}

a {
  color: #ffffff;
}
</style>